import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export type PillTone = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

// The icon plus the label carry the meaning, so status is never conveyed by colour alone.
const StatusPill: React.FC<{ tone: PillTone; label: string; large?: boolean }> = ({ tone, label, large }) => {
  const { palette } = useTheme();
  const t = palette.tokens;
  const color = { success: t.success, warning: t.warning, danger: t.error, neutral: t.mutedSoft, info: t.primary }[tone];
  const Icon = { success: CheckCircleOutlineIcon, warning: WarningAmberIcon, danger: ErrorOutlineIcon, neutral: RemoveCircleOutlineIcon, info: InfoOutlinedIcon }[tone];
  return (
    <Box
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.5, borderRadius: 999, flexShrink: 0,
        px: large ? 2 : 1, py: large ? 0.5 : 0.25,
        bgcolor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.35)}`,
      }}
    >
      {!large && <Icon aria-hidden sx={{ fontSize: 14, color }} />}
      <Typography component="span" sx={{ fontSize: large ? '0.95rem' : '0.75rem', fontWeight: large ? 700 : 600, color: t.ink, lineHeight: 1.4, whiteSpace: 'nowrap', letterSpacing: large ? '0.01em' : undefined }}>
        {label}
      </Typography>
    </Box>
  );
};

export default StatusPill;
